import { Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CommunicationService } from 'app/_services/communication.service';
import { GanttService } from 'app/_services/gantt.service';
import { AppComponent } from 'app/app.component';
import { DxGanttComponent } from 'devextreme-angular';
import { IGanttTask } from 'app/_models/IGanttTask';
import { IGanttDependency } from 'app/_models/IGanttDependency';
import { ISourceViewHeader } from 'app/_models/ISourceViewHeader';
import { ILookupValues } from 'app/_models/ILookupValues';
import { IGanttData } from 'app/_models/IGanttData';
import { ISettings } from 'app/_models/ISettings';
import { IconDefinition, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IAction } from 'app/_models/IAction';
import { DatePipe } from '@angular/common';
import { IGanttResource } from 'app/_models/IGanttResource';
import { IGanttAssignment } from 'app/_models/IGanttAssignment';

@Component({
  selector: 'app-gantt',
  templateUrl: './gantt.component.html',
  styleUrls: ['./gantt.component.css']
})
export class GanttComponent implements OnInit {
  //#region Fields
  @Input() settings: ISettings;
  @Input() nodeId: string;
  @Input() userId: string;
  @Input() username: string;
  serverDateFormat: string;
  ganttData: IGanttData;
  keyValue: string;
  keyId: string;
  selectedTasks: IGanttTask[] = [];
  ganttTasks: IGanttTask[] = [];
  ganttDependencies: IGanttDependency[] = [];
  headers: ISourceViewHeader[] = [];
  projectData: ILookupValues[] = [];
  ganttResources: IGanttResource[] = [];
  ganttAssignments: IGanttAssignment[] = [];
  @ViewChild('ganttChart', { static: false }) ganttChart: DxGanttComponent;
  comboOpen: boolean = false;
  filteredLookupValues: { lookUpValue: ILookupValues, selected: boolean }[] = [];
  updateAction: IAction;
  faChevronDown: IconDefinition = faChevronDown;
  //#endregion

  constructor(
    public app: AppComponent,
    private communicationService: CommunicationService,
    private ganttService: GanttService,
    private datePipe: DatePipe
  ) {
    this.communicationService.base_gantt_loadGantt$.subscribe((nodeId) => {
      this.nodeId = nodeId;
      this.loadGantt();
    })
  }

  ngOnInit(): void {
    if (localStorage.getItem('qx_direct')) this.communicationService.loadRadButtons('Projects', this.nodeId);
    this.loadProjects();
  }

  loadProjects(): void {
    let keys = ['nodeId', 'userId', 'viewName', 'keyValue'];
    let values = [this.nodeId, this.userId, 'Projects', this.keyValue];
    let formData = this.app.buildForm(keys, values);
    this.ganttService.getData(formData).subscribe({
      next: (data: { resultData: ILookupValues[], dateFormat: string }) => {
        this.app.hideLoader();
        this.projectData = data.resultData;
        this.serverDateFormat = data.dateFormat;

        if (localStorage.getItem('qx_direct')) {
          let projectId = JSON.parse(localStorage.getItem('qx_direct')).lineId;
          if (!projectId) return;
          this.keyValue = projectId;
          localStorage.removeItem('qx_direct');
          this.app.showLoader();
          this.loadGantt();
        }
      }, error: (errorLog) => {
        this.app.hideLoader();
        if (this.settings.detailedErrorSetting) {
          sessionStorage.setItem('errorDetails', JSON.stringify(errorLog.error));
          this.app.router.navigate(["error"]);
          return;
        }

        console.log(errorLog);
        this.app.alertError(`${this.app.translations.ALERT_Error_ErrorWithRefNumberOccured}: ${errorLog.error.refNumber}`);
      }
    });
  }

  loadGantt(): void {
    if (sessionStorage.getItem('qx_ganttUpdateAction')) {
      this.updateAction = JSON.parse(sessionStorage.getItem('qx_ganttUpdateAction'));
      sessionStorage.removeItem('qx_ganttUpdateAction');
    }

    let keys = ['nodeId', 'userId', 'viewName', 'keyValue'];
    let values = [this.nodeId, this.userId, 'Gant', this.keyId];
    let formData = this.app.buildForm(keys, values);
    this.ganttService.getData(formData).subscribe({
      next: (data: IGanttData) => {
        this.app.hideLoader();
        this.ganttTasks = data.tasks;
               
        for (let i = 0; i < this.ganttTasks.length; i++) {
          let element = this.ganttTasks[i];
          if (this.settings.dateFormatSetting == 'dd/MM/yyyy') {
            let dateValuesStart = element.start.split('/');           
            element.start = `${dateValuesStart[1]}/${dateValuesStart[0]}/${dateValuesStart[2]}` as any;

            let dateValuesEnd = element.end.split('/');           
            element.end = `${dateValuesEnd[1]}/${dateValuesEnd[0]}/${dateValuesEnd[2]}` as any;
          }
        }
                
        this.ganttDependencies = data.dependencies;
        this.headers = data.headers;
        this.ganttResources = data.resources;
        this.ganttAssignments = data.assignments;
        this.communicationService.updateRadHeaders(this.headers, data.dateFormat);
      }, error: (errorLog) => {
        this.app.hideLoader();
        if (this.settings.detailedErrorSetting) {
          sessionStorage.setItem('errorDetails', JSON.stringify(errorLog.error));
          this.app.router.navigate(["error"]);
          return;
        }

        console.log(errorLog);
        this.app.alertError(`${this.app.translations.ALERT_Error_ErrorWithRefNumberOccured}: ${errorLog.error.refNumber}`);
      }
    });
  }

  selectTask(event: any): void {
    if (event.key != 0 || event.key != '') {
      this.ganttTasks.forEach(task => task.color = task.originalColor);
      var task = this.ganttTasks.find(tsk => tsk.id == event.key);
      if (!task) return;

      var dependency = this.ganttDependencies.find(dependency => dependency.successorId == task.id);
      if (dependency) task.pred = dependency.predecessorId.toString();

      task.selected = !task.selected;
      task.color = task.selected ? task.color = '#72b92b' : task.originalColor;
      this.selectedTasks = [];
      if (task.selected) this.selectedTasks.push(task);

      let lineItem = [{ id: this.keyValue, lineData: null, lineNumber: null }];
      this.communicationService.filterRadButtons(task.selected ? 'Gant' : 'Projects', this.selectedTasks.length > 0 ? this.selectedTasks : lineItem);
      this.ganttTasks = [...this.ganttTasks];            
    }
  }

  //#region Combo
  openDropdown(event: Event, op: OverlayPanel): void {
    this.filteredLookupValues = [];
    for (let index = 0; index < this.projectData.length; index++) {
      let element = this.projectData[index];
      let selected = false;

      if (!this.keyValue || this.keyValue === '') {
        selected = index === 0;
      } else {
        selected = this.keyValue === element.value;
      }

      this.filteredLookupValues.push({ lookUpValue: element, selected });
    }

    this.comboOpen = true;
    op.show(event);
    let selectedIndex = this.filteredLookupValues.findIndex(v => v.selected);
    if (selectedIndex) this.scrollToOption(selectedIndex);
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent): void {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      if (!this.comboOpen) return;

      if (!this.filteredLookupValues) return;
      let selectedIndex = this.filteredLookupValues.findIndex(v => v.selected);
      if (selectedIndex === -1) return;

      if (event.key === 'ArrowUp' && selectedIndex > 0) {
        this.filteredLookupValues[selectedIndex].selected = false;
        this.filteredLookupValues[selectedIndex - 1].selected = true;
        this.keyValue = '';
        this.scrollToOption(selectedIndex - 1);
      }

      if (event.key === 'ArrowDown' && selectedIndex < this.filteredLookupValues.length - 1) {
        this.filteredLookupValues[selectedIndex].selected = false;
        this.filteredLookupValues[selectedIndex + 1].selected = true;
        this.keyValue = '';
        this.scrollToOption(selectedIndex + 1);
      }
    }
  }

  @ViewChildren('optionEl', { read: ElementRef }) optionEls!: QueryList<ElementRef>;
  scrollToOption(index: number) {
    let element = this.optionEls.toArray()[index]?.nativeElement;
    if (element) element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  change(event: KeyboardEvent): void {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') return;
    if (this.keyValue.length > 0) {
      let a = this.projectData.filter(item => item.value.toLowerCase().includes(this.keyValue.toLowerCase()));
      this.filteredLookupValues = [];
      for (let index = 0; index < a.length; index++) {
        this.filteredLookupValues.push({ lookUpValue: a[index], selected: false });
      }

      if (this.filteredLookupValues.length > 0) this.filteredLookupValues[0].selected = true;
    }
    else {
      this.filteredLookupValues = [];
      for (let index = 0; index < this.projectData.length; index++) {
        this.filteredLookupValues.push({ lookUpValue: this.projectData[index], selected: false });
      }
    }
  }

  updateCombos(selectedLookupValue: any, op: OverlayPanel): void {
    this.keyValue = selectedLookupValue.lookUpValue.value;
    this.keyId = selectedLookupValue.lookUpValue.id;
    let currentSelectedValue = this.filteredLookupValues.find(v => v.selected);
    if (currentSelectedValue) {
      currentSelectedValue.selected = false;
    }
    selectedLookupValue.selected = true;

    this.comboOpen = false;
    op.hide();
    this.loadGantt();
    this.communicationService.filterRadButtons('Projects', [{ id: this.keyValue, lineData: null, lineNumber: null }]);
  }
  //#endregion

  onTaskUpdated(event: any): void {   
    let task = this.ganttTasks.find(task => task.id == event.key);
    if (task) this.saveUpdatedGanttTask(task);
  }

  onResourceAssigning(event: any): void {
    let task = this.ganttTasks.find(task => task.id == event.values.taskId);
    if (task) {
      task.resourcename = `${task.resourcename},${event.values.resourcename},`;
      this.saveUpdatedGanttTask(task);
    }
  }

  onResourceUnassigned(event: any): void {
    let task = this.ganttTasks.find(task => task.id == event.values.taskId);
    if (task) {
      task.resourcename = task.resourcename.replace(`${event.values.resourcename},`, '');
      this.saveUpdatedGanttTask(task);
    }
  }

  saveUpdatedGanttTask(task: IGanttTask): void {
    this.updateAction.parameters.forEach(param => {
      if (param.name == 'TITLE') param.value = task.title;
      if (param.name == 'START') param.value = this.datePipe.transform(new Date(task.start), 'MM/dd/yyyy');      
      if (param.name == 'END') param.value = this.datePipe.transform(new Date(task.end), 'MM/dd/yyyy');      
      if (param.name == 'PROGRESS') param.value = task.progress;
      if (param.name == 'PARENT') param.value = task.parent;
      if (param.name == 'PRED') param.value = task.pred;
      if (param.name == 'RESOURCES') param.value = task.resourcename;
    })

    let keys = ['nodeId', 'userId', 'actionId', 'taskId', 'parameters'];
    let values = [this.nodeId, this.userId, this.updateAction.id, task.id, JSON.stringify(this.updateAction.parameters)];
    let formData = this.app.buildForm(keys, values);
    this.ganttService.updateGanttTask(formData).subscribe();
  }  
}